import { configureStore, StateFromReducersMapObject } from '@reduxjs/toolkit';
import {
  fullscreenSlice,
  infrastructureSlice,
  mapBoundsSlice,
  pageSlice,
  panoramaSlice,
  paramsSlice,
  similarNewbuildingsSlice,
  transportAccessibilitySlice,
} from 'shared/mf-infrastructure/slices';
import { similarObjectsSlice } from 'shared/mf-infrastructure/slices/similarObjectsSlice';
import { IApplicationContext } from 'shared/mf-infrastructure/types/applicationContext';
import { initIsLogoRedesignEnabled } from 'shared/mf-infrastructure/utils/logoRedesign/isLogoRedesignEnabled';

const reducer = {
  [panoramaSlice.name]: panoramaSlice.reducer,
  [paramsSlice.name]: paramsSlice.reducer,
  [pageSlice.name]: pageSlice.reducer,
  [infrastructureSlice.name]: infrastructureSlice.reducer,
  [transportAccessibilitySlice.name]: transportAccessibilitySlice.reducer,
  [mapBoundsSlice.name]: mapBoundsSlice.reducer,
  [similarObjectsSlice.name]: similarObjectsSlice.reducer,
  [similarNewbuildingsSlice.name]: similarNewbuildingsSlice.reducer,
  [fullscreenSlice.name]: fullscreenSlice.reducer,
};

type TApplicationState = StateFromReducersMapObject<typeof reducer>;

/**
 * Хелпер для создания Redux стора
 * @param context IApplicationContext - контекст приложения
 * @param preloadedState IPreloadedState - предзагруженное состояние
 * @param debugEnabled boolean - флаг доступности Redux Devtools на деве
 */
export const createReduxStore = (
  context: IApplicationContext,
  preloadedState: Partial<TApplicationState>,
  debugEnabled: boolean,
) => {
  const projectName = context.config.getStrict<string>('projectName');

  initIsLogoRedesignEnabled(context);

  return configureStore({
    preloadedState,
    reducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: context,
        },
      }),
    devTools: debugEnabled ? { name: projectName } : false,
  });
};
